import * as z from 'zod';

import { FeeId, LosId } from '../../BrandedIds';

export const CancelLoanFeeRow = z.object({
  loanId: LosId,
  feeId: FeeId,
  comment: z.string().optional(),
});
export type CancelLoanFeeRow = z.infer<typeof CancelLoanFeeRow>;
